import axios from './index'
import url from './url'

// 获取企业性质接口
function getRuzhuinfo (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/getRuzhuinfo`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取机构/学校属性
function getShuxing (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/getShuxing`,
    { params: typeOne }
  )
}

// 获取机构/学校属性
function getLeibie (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getLeibie`,
    { params: typeOne }
  )
}

// 编辑学校入驻信息
function editRuzhuSchoolinfo (typeOne, urlType) {
  return axios.post(
    `${url.wz}/public/v1/user/edu/${urlType}`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取学校详细信息
function getDetailSchool (typeOne, urlType) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/${urlType}`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 组织机构列表
function getZuzhiList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/zuzhiList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除企业商品接口
function getDelZuzhi (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delZuzhi`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 校园信息列表
function getNoticeList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/noticeList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除企业商品接口
function getDelNotice (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delNotice`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 毕业届/在校生班级列表
function getBanjiList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/banjiList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除企业商品接口
function getDelBanji (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delBanji`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 校友中心公告列表
function getXiaoyouNoticeList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/xiaoyouNoticeList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除校友中心公告
function getDelXiaoyouNotice (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delXiaoyouNotice`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取校友中心基本信息
function getXiaoyouBaseinfo (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/getXiaoyouBaseinfo`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 校友中心公告列表
function getSchoolTeacherList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/schoolTeacherList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除校友中心公告
function getDelSchoolTeacher (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delSchoolTeacher`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 校友中心公告列表
function getKewuList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/kewuList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除课务
function getDelKewu (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delKewu`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 课件列表
function getKejianList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/kejianList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 删除课件
function getDelKejian (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delKejian`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 课件订单列表
function getKejianOrderList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/kejianOrderList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 生成学校添加老师需要的验证码
function getTeacherVcode (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/getTeacherVcode`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 用户购买课件订单列表
function getUserKejianOrderList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/userKejianOrderList`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 用户删除购买课件订单
function getDelUserKejianOrder (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/delUserKejianOrder`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

// 获取入驻二级分类
function getRuzhuCategory (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/user/edu/getRuzhuCategory`,
    {
      params: typeOne,
      headers: {
        // token携带
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // formdata头部设置
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

export {
  getRuzhuinfo,
  getShuxing,
  getLeibie,
  editRuzhuSchoolinfo,
  getDetailSchool,
  getZuzhiList,
  getDelZuzhi,
  getNoticeList,
  getDelNotice,
  getBanjiList,
  getDelBanji,
  getXiaoyouNoticeList,
  getDelXiaoyouNotice,
  getXiaoyouBaseinfo,
  getSchoolTeacherList,
  getDelSchoolTeacher,
  getKewuList,
  getDelKewu,
  getKejianList,
  getDelKejian,
  getKejianOrderList,
  getTeacherVcode,
  getUserKejianOrderList,
  getDelUserKejianOrder,
  getRuzhuCategory
}



// WEBPACK FOOTER //
// ./src/axios/userEducation.js